import isEmpty from 'is-empty';
import {
  WITHDRAW_FIXED_SAVING_SUCCESS,
  WITHDRAW_FIXED_SAVING_ERROR,
  WITHDRAW_FIXED_SAVING_LOADING,
  WITHDRAW_FIXED_SAVING_ERROR_DELETE
} from '../../actions/types';

const initialState = {
  success: false,
  withdrawFixedSavings: {},
  error: '',
  loading: false
};

const WithdrawFixedSavings = (state = initialState, action) => {
  switch (action.type) {
    case WITHDRAW_FIXED_SAVING_SUCCESS:
      return {
        ...state,
        withdrawFixedSavings: action.withdrawal,
        success: !isEmpty(action.withdrawal),
        loading: false
      };
    case WITHDRAW_FIXED_SAVING_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case WITHDRAW_FIXED_SAVING_ERROR_DELETE:
      return {
        ...state,
        error: '',
        loading: false
      };
    case WITHDRAW_FIXED_SAVING_LOADING:
      return {
        ...state,
        loading: true
      };
    default: return state;
  }
};

export default WithdrawFixedSavings;